// src/components/Home/ServicesGrid.jsx
import React from "react";
import {
  FaShip,
  FaPlane,
  FaTruck,
  FaFileContract,
  FaWarehouse,
  FaNetworkWired,
} from "react-icons/fa";
import "./ServicesGrid.css";

const ServicesGrid = () => {
  const services = [
    {
      icon: <FaShip />,
      title: "Sea Freight Shipping",
      description:
        "Cost-efficient FCL/LCL with dependable ETAs and proactive milestone updates. EXW/FOB coordination, Port handling at Mombasa & ICD.",
      features: [
        "FCL & LCL Shipping",
        "Port Handling",
        "EXW/FOB Coordination",
        "Mombasa & ICD",
      ],
      transitTime: "25-40 days",
      color: "#1a73e8",
    },
    {
      icon: <FaPlane />,
      title: "Air Freight Services",
      description:
        "Priority uplift via JKIA with tight transit times and compliant documentation. Airline bookings & AWB, Urgent spares & perishables.",
      features: [
        "JKIA Priority Uplift",
        "Airline Bookings",
        "Urgent Spares",
        "Perishables",
      ],
      transitTime: "1-5 days",
      color: "#fbbc04",
    },
    {
      icon: <FaTruck />,
      title: "Road Transport",
      description:
        "Reliable trucking for port-to-ICD, last-mile and up-country deliveries. Container & loose cargo handling, Secure, GPS-tracked movements.",
      features: [
        "Port-to-ICD",
        "Last-Mile Delivery",
        "GPS Tracking",
        "Cross-Border",
      ],
      transitTime: "Flexible",
      color: "#34a853",
    },
    {
      icon: <FaFileContract />,
      title: "Customs Clearance & Brokerage",
      description:
        "Licensed KRA processes that reduce dwell time and prevent penalties. IDF, HS classification, permits (KEBS/PPB), Inspections & audit-ready documentation.",
      features: [
        "KRA Licensed",
        "HS Classification",
        "Permit Coordination",
        "1-3 Day Clearance",
      ],
      transitTime: "1-3 days",
      color: "#ea4335",
    },
    {
      icon: <FaWarehouse />,
      title: "Warehousing & Distribution",
      description:
        "Secure storage with pick & pack and nationwide distribution. Inventory control & KPI reporting, Retail, B2B & e-commerce fulfilment.",
      features: [
        "Bonded Storage",
        "Pick & Pack",
        "E-commerce Fulfillment",
        "Nationwide",
      ],
      capacity: "50,000+ sq ft",
      color: "#1a73e8",
    },
    {
      icon: <FaNetworkWired />,
      title: "Supply Chain Management",
      description:
        "PO-to-POD coordination, documentation and cost control for predictable delivery. Vendor & milestone management, Transparent, sales-ready pricing.",
      features: [
        "PO-to-POD",
        "Real-time Tracking",
        "Vendor Management",
        "ERP Ready",
      ],
      coverage: "End-to-End",
      color: "#fbbc04",
    },
  ];

  return (
    <section className="services-grid-section section section-light">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2>Core Logistics & Shipping Services</h2>
          <p className="section-subtitle">
            High-reliability shipping services, air shipments, and licensed
            customs clearance—covering sea, air & road across Nairobi ICD,
            Mombasa Port and JKIA.
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card card">
              {/* Card Header */}
              <div className="service-header">
                <div
                  className="service-icon-wrapper"
                  style={{
                    background: `linear-gradient(135deg, ${service.color}20, ${service.color}40)`,
                    border: `2px solid ${service.color}30`,
                  }}
                >
                  <div
                    className="service-icon"
                    style={{ color: service.color }}
                  >
                    {service.icon}
                  </div>
                </div>
                <h3 className="service-title">{service.title}</h3>
              </div>

              {/* Service Description */}
              <p className="service-description">{service.description}</p>

              {/* Features List */}
              <div className="service-features">
                <h4>Key Features:</h4>
                <ul className="features-list">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="feature-item">
                      <span
                        className="feature-bullet"
                        style={{ backgroundColor: service.color }}
                      ></span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Service Footer */}
              <div className="service-footer">
                <div className="service-meta">
                  {service.transitTime && (
                    <div className="meta-item">
                      <span className="meta-label">Transit Time:</span>
                      <span className="meta-value">{service.transitTime}</span>
                    </div>
                  )}
                  {service.capacity && (
                    <div className="meta-item">
                      <span className="meta-label">Capacity:</span>
                      <span className="meta-value">{service.capacity}</span>
                    </div>
                  )}
                  {service.coverage && (
                    <div className="meta-item">
                      <span className="meta-label">Coverage:</span>
                      <span className="meta-value">{service.coverage}</span>
                    </div>
                  )}
                </div>
                <button
                  className="service-cta btn btn-primary"
                  style={{ backgroundColor: service.color }}
                >
                  Learn More
                </button>
              </div>

              {/* Card Accent */}
              <div
                className="service-accent"
                style={{ backgroundColor: service.color }}
              ></div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="services-cta">
          <div className="cta-content text-center">
            <h3>Need a Custom Logistics Solution?</h3>
            <p>
              We tailor our services to meet your specific business requirements
              and supply chain needs.
            </p>
            <div className="cta-buttons">
              <button className="btn btn-primary btn-large">
                Get Free Consultation
              </button>
              <button className="btn btn-secondary btn-large">
                View All Services
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
